import { render, staticRenderFns } from "./WeightSection.vue?vue&type=template&id=16feca11&"
import script from "./WeightSection.vue?vue&type=script&lang=js&"
export * from "./WeightSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports